import { Navbar } from "reactstrap";
import styled from "styled-components";

export const NavbarWithHeight = styled(Navbar)`
	height: 10vh;
	overflow-x: visible;
	overflow-y: hidden;
`;
